<template>
    <div class="mx-auto grid max-w-7xl grid-cols-1 gap-5 lg:grid-cols-3 lg:items-start">
        <div class="overflow-hidden rounded-[1.75rem] border border-[#E5E4E1] bg-[#F7F7F5] shadow-[0_0.75rem_2rem_rgba(23,25,35,0.06)]">
            <div class="border-b border-[#E5E4E1] bg-[#E8E8E5] p-7">
                <p class="text-xs font-extrabold uppercase tracking-[0.16em] text-[#5F626D]">Essential foundation</p>
                <h3 class="mt-3 text-3xl font-extrabold tracking-tight text-nomad-primary">Starter Spark</h3>
                <p class="mt-4 min-h-20 text-base leading-relaxed text-[#5F626D]">Ideal for beginners with essential requirements, our Spark Starter Plan provides fundamental services to establish a robust online presence.</p>
                <div>
                    <div class="mt-7 text-3xl font-extrabold text-nomad-primary">$1,989</div>
                    <span class="text-xs font-medium text-[#5F626D]">65% down payment required</span>
                </div>
                <router-link to="/checkout" class="mt-5 inline-flex rounded-full border-2 border-nomad-primary px-5 py-2.5 text-sm font-extrabold text-nomad-primary transition hover:bg-nomad-primary hover:text-nomad-accent">Pay now</router-link>
            </div>
            <div class="text-center">
                <ul class="my-3 grid gap-4 px-6 py-3 text-left text-nomad-primary">
                    <li class="flex gap-2" v-for="spark in visibleItems(sparks, 'sparks')" :key="spark.id">
                        <div class="pt-1"><span class="icon-check-circle"></span></div>
                        <div class="flex min-h-[3.25rem] flex-1 flex-col justify-center">
                            <div class="line-clamp-2 font-bold">{{ spark.text }}</div>
                            <div class="mt-1 text-sm leading-relaxed text-gray-500">{{ spark.description }}</div>
                        </div>
                    </li>
                </ul>

                <button v-if="sparks.length > 3" @click="toggleItems('sparks')" class="mb-4 inline-flex items-center gap-2 px-3 py-2 text-sm font-extrabold uppercase tracking-[0.12em] text-nomad-primary transition hover:text-nomad-primary/80">
                    {{ expanded.sparks ? 'Show less' : 'Show more' }}
                    <ChevronDown :class="['h-4 w-4 transition-transform', expanded.sparks ? 'rotate-180' : '']" />
                </button>
            </div>
        </div>
        <div class="overflow-hidden rounded-[1.75rem] bg-nomad-primary text-white shadow-[0_1.25rem_2.75rem_rgba(43,41,73,0.24)] lg:-mt-4">
            <div class="relative border-b border-white/10 bg-[#373251] p-7 text-center">
                <div class="inline-flex rounded-full bg-nomad-accent px-3 py-1 text-xs font-extrabold uppercase tracking-[0.14em] text-nomad-primary">Popular</div>
                <h3 class="mt-5 text-3xl font-extrabold tracking-tight text-white">Growth Gear</h3>
                <p class="mt-4 min-h-20 text-base leading-relaxed text-white/75">Upgrade to the Growth Plan for comprehensive features, perfect for clients with more extensive requirements.</p>
                <div>
                    <div class="mt-7 text-3xl font-extrabold text-nomad-accent">$5,989</div>
                    <span class="text-xs font-medium text-white/70">55% down payment required</span>
                </div>
                <router-link to="/checkout" class="mt-5 inline-flex rounded-full bg-nomad-accent px-5 py-2.5 text-sm font-extrabold text-nomad-primary transition hover:bg-nomad-light">Pay now</router-link>
            </div>
            <div class="text-center">
                <ul class="my-3 grid gap-4 px-6 py-3 text-left text-white">
                    <li class="flex gap-2" v-for="spark in visibleItems(grows, 'grows')" :key="spark.id">
                        <div class="pt-1 text-nomad-accent"><span class="icon-check-circle"></span></div>
                        <div class="flex min-h-[3.25rem] flex-1 flex-col justify-center">
                            <div class="line-clamp-2 font-bold">{{ spark.text }}</div>
                            <div class="mt-1 text-sm leading-relaxed text-white/70">{{ spark.description }}</div>
                        </div>
                    </li>
                </ul>

                <button v-if="grows.length > 3" @click="toggleItems('grows')" class="mb-4 inline-flex items-center gap-2 px-3 py-2 text-sm font-extrabold uppercase tracking-[0.12em] text-nomad-accent transition hover:text-nomad-accent/80">
                    {{ expanded.grows ? 'Show less' : 'Show more' }}
                    <ChevronDown :class="['h-4 w-4 transition-transform', expanded.grows ? 'rotate-180' : '']" />
                </button>
            </div>
        </div>
        <div class="overflow-hidden rounded-[1.75rem] border border-[#E5E4E1] bg-[#F7F7F5] shadow-[0_0.75rem_2rem_rgba(23,25,35,0.06)]">
            <div class="border-b border-[#E5E4E1] bg-[#E8E8E5] p-7 text-left">
                <p class="text-xs font-extrabold uppercase tracking-[0.16em] text-[#5F626D]">Full-service growth</p>
                <h3 class="mt-3 text-3xl font-extrabold tracking-tight text-nomad-primary">Pinnacle Pulse</h3>
                <p class="mt-4 min-h-20 text-base leading-relaxed text-[#5F626D]">Our ultimate option delivers a comprehensive, premium experience with advanced features and top-priority support.</p>
                <div>
                    <div class="mt-7 text-3xl font-extrabold text-nomad-primary">Starting $12k</div>
                    <span class="text-xs font-medium text-[#5F626D]">45% down payment required</span>
                </div>
                <router-link to="/contact" class="mt-5 inline-flex rounded-full border-2 border-nomad-primary px-5 py-2.5 text-sm font-extrabold text-nomad-primary transition hover:bg-nomad-primary hover:text-nomad-accent">Let&apos;s talk</router-link>
            </div>
            <div class="text-center">
                <ul class="my-3 grid gap-4 px-6 py-3 text-left text-nomad-primary">
                    <li class="flex gap-2" v-for="spark in visibleItems(pinnacles, 'pinnacles')" :key="spark.id">
                        <div class="pt-1"><span class="icon-check-circle"></span></div>
                        <div class="flex min-h-[3.25rem] flex-1 flex-col justify-center">
                            <div class="line-clamp-2 font-bold">{{ spark.text }}</div>
                            <div class="mt-1 text-sm leading-relaxed text-gray-500">{{ spark.description }}</div>
                        </div>
                    </li>
                </ul>

                <button v-if="pinnacles.length > 3" @click="toggleItems('pinnacles')" class="mb-4 inline-flex items-center gap-2 px-3 py-2 text-sm font-extrabold uppercase tracking-[0.12em] text-nomad-primary transition hover:text-nomad-primary/80">
                    {{ expanded.pinnacles ? 'Show less' : 'Show more' }}
                    <ChevronDown :class="['h-4 w-4 transition-transform', expanded.pinnacles ? 'rotate-180' : '']" />
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { ChevronDown } from '@lucide/vue';

export default {
    components: {
        ChevronDown
    },
    data() {
        return {
            expanded: {
                sparks: false,
                grows: false,
                pinnacles: false
            },
            sparks: [
                {
                    id: 1,
                    text: "Business Package",
                    description: "Our all-inclusive package to kickstart your online presence and success."
                },
                {
                    id: 1,
                    text: "Infrastructure setup",
                    description: "We handle the technical aspects, from web hosting to domain registration, to get your website online."
                },
                {
                    id: 1,
                    text: "Logo Design",
                    description: "Our designers create a unique logo that represents your brand's identity and professionalism."
                },
                {
                    id: 1,
                    text: "Design options",
                    description: "Choose from a few polished looks to match your brand without starting from scratch."
                },
                {
                    id: 1,
                    text: "Social Media Setup",
                    description: "We set up and optimize your social media profiles, making it easy to connect with your audience."
                },
                {
                    id: 1,
                    text: "Email Setup",
                    description: "Ensure an excellent user experience on all devices, including mobile phones and tablets."
                },
                {
                    id: 1,
                    text: "Basic SEO",
                    description: "We ensure that your website is search engine-friendly, helping potential customers find you online."
                },
                {
                    id: 1,
                    text: "Security Measures",
                    description: "Protect your website and customer data with robust security measures."
                }
            ],
            grows: [
                {
                    id: 1,
                    text: "Everthing in Spark",
                    description: "Our all-inclusive package to kickstart your online presence and success."
                },
                {
                    id: 1,
                    text: "Email Markting",
                    description: "Leverage the power of email campaigns to engage and convert your audience."
                },
                {
                    id: 1,
                    text: "Custom Template",
                    description: " Enjoy a unique website design tailored to your brand and vision."
                },
                {
                    id: 1,
                    text: "Up to 2 Third-Party Integrations",
                    description: "Seamlessly connect your website with external tools and platforms."
                },
                {
                    id: 1,
                    text: "E-commerce Analytics",
                    description: "Gain valuable insights into your online store's performance."
                },
                {
                    id: 1,
                    text: "Newsletter Signup",
                    description: "Attract and retain customers with a dedicated newsletter sign-up feature."
                },
                {
                    id: 1,
                    text: "Ad Manager Integration",
                    description: "Effortlessly manage and optimize your online advertisements."
                },
                {
                    id: 1,
                    text: "Google Ads Setup",
                    description: "Harness the potential of Google Ads to boost your online visibility."
                },
                {
                    id: 1,
                    text: "Advanced SEO",
                    description: "Go beyond basic SEO by offering advanced strategies, keyword research, and competitive analysis to improve search rankings."
                },
                {
                    id: 1,
                    text: "Performance Optimization",
                    description: "Optimize website speed, performance, and loading times for an enhanced user experience."
                },
                {
                    id: 1,
                    text: "2 months support",
                    description: "Enjoy priority access to our support team for rapid assistance and solutions to any inquiries or issues."
                },
                {
                    id: 1,
                    text: "Dedicated Account Manager *",
                    description: "Assign a dedicated account manager to provide personalized support and guidance throughout the client's journey."
                }
            ],
            pinnacles: [
                {
                    id: 1,
                    text: "Everything in Growth Gear",
                    description: "All the core growth tools and strategy support in one package."
                },
                {
                    id: 1,
                    text: "Advanced SEO",
                    description: "Improve rankings and visibility with smarter, data-driven SEO."
                },
                {
                    id: 1,
                    text: "Content strategy",
                    description: "Build brand authority with useful, high-quality content across channels."
                },
                {
                    id: 1,
                    text: "Comprehensive Social Media Management",
                    description: "Harness the full potential of social platforms with a comprehensive social media management strategy, including content creation, engagement, and audience growth."
                },
                {
                    id: 1,
                    text: "E-commerce Expansion",
                    description: "Expand your online store's capabilities with advanced e-commerce features, integrations, and personalized product recommendations."
                },
                {
                    id: 1,
                    text: "Advanced Analytics and Reporting",
                    description: "Dive deep into data-driven insights, track user behavior, and fine-tune your strategies for optimal results."
                },
                {
                    id: 1,
                    text: "Personalized Email Campaigns",
                    description: "Engage your audience with personalized email marketing campaigns, tailored to individual preferences and behavior."
                },
                {
                    id: 1,
                    text: "24/7 Priority Support",
                    description: "Enjoy priority access to our support team for rapid assistance and solutions to any inquiries or issues, up to 3 months without hourly subscription."
                },
                {
                    id: 1,
                    text: "Custom Strategy Sessions",
                    description: "Benefit from personalized strategy sessions to align your online presence with your long-term business goals."
                },
            ]
        }
    },
    methods: {
        visibleItems(items, key) {
            if (this.expanded[key]) {
                return items;
            }

            return items.slice(0, 3);
        },
        toggleItems(key) {
            this.expanded[key] = !this.expanded[key];
        }
    }
}
</script>